// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v6.30.2
// source: autoqa.proto

/* eslint-disable */
import type { Empty } from "./google/protobuf/empty";

export const protobufPackage = "proto";

export enum SpotlightSignal {
  POSITIVE = "POSITIVE",
  NEUTRAL = "NEUTRAL",
  NEGATIVE = "NEGATIVE",
}

export interface CustomCategoryTemplateFiltersResponse {
  templateFilters: TemplateFilter[];
  templateRatingFilters: TemplateFilter[];
}

export interface SpotlightConditionResponse {
  conditions: TemplateFilter[];
  setupFilters: SpotlightSetupFilters[];
}

export interface SpotlightSetupFilters {
  spotlight: string;
  filters: TemplateFilter[];
}

export interface TemplateFilter {
  type: TemplateFilter_TemplateFilterTypeCode;
  allowedMultiple: boolean;
  label: string;
  conditions: TemplateFilterCondition[];
  values: TemplateFilterValue[];
}

export enum TemplateFilter_TemplateFilterTypeCode {
  AGENT_MESSAGE = "AGENT_MESSAGE",
  SOURCE_TYPE = "SOURCE_TYPE",
  TICKET_CHANNEL = "TICKET_CHANNEL",
  TICKET_TAGS = "TICKET_TAGS",
  CALL_DIRECTION = "CALL_DIRECTION",
  DEADAIR = "DEADAIR",
  TICKET_BRAND = "TICKET_BRAND",
  TICKET_SENTIMENT = "TICKET_SENTIMENT",
  LANGUAGE = "LANGUAGE",
  CLIENT_MESSAGE = "CLIENT_MESSAGE",
  ALL_MESSAGES = "ALL_MESSAGES",
  TICKET_ESCALATION = "TICKET_ESCALATION",
}

export interface TemplateFilterCondition {
  condition: TemplateFilterCondition_TemplateFilterConditionCode;
  labelCode: string;
}

export enum TemplateFilterCondition_TemplateFilterConditionCode {
  STRING_EQUALS = "STRING_EQUALS",
  STRING_NOT_EQUALS = "STRING_NOT_EQUALS",
  STRING_CONTAINS = "STRING_CONTAINS",
  STRING_NOT_CONTAINS = "STRING_NOT_CONTAINS",
  STRING_LIST_EQUALS = "STRING_LIST_EQUALS",
  STRING_LIST_NOT_EQUALS = "STRING_LIST_NOT_EQUALS",
  INTEGER_HIGHER = "INTEGER_HIGHER",
  ALL_STRINGS_EQUAL = "ALL_STRINGS_EQUAL",
  ALL_STRINGS_CONTAIN = "ALL_STRINGS_CONTAIN",
  ALL_STRINGS_NOT_EQUAL = "ALL_STRINGS_NOT_EQUAL",
  ALL_STRINGS_NOT_CONTAIN = "ALL_STRINGS_NOT_CONTAIN",
  STRING_LIST_CONTAINS = "STRING_LIST_CONTAINS",
  STRING_LIST_NOT_CONTAINS = "STRING_LIST_NOT_CONTAINS",
}

export interface TemplateFilterValue {
  value: string;
}

export interface CustomCategoryTemplatesResponse {
  templates: CustomCategoryTemplate[];
}

export interface CustomCategoryTemplate {
  id: string;
  name: string;
  scale: AddCustomCategoryTemplateRequest_Scale;
  createdAt: string | undefined;
  conditions: CustomCategoryTemplateCondition[];
  ratings: CustomCategoryTemplateRating[];
}

export interface CustomCategoryTemplateCondition {
  type: TemplateFilter_TemplateFilterTypeCode;
  condition: TemplateFilterCondition_TemplateFilterConditionCode;
  values: CustomCategoryTemplateValue[];
}

export interface CustomCategoryTemplateValue {
  value: string;
}

export interface CustomCategoryTemplateRating {
  id: string;
  ratingScaleNumericScore: string;
  conditions: CustomCategoryTemplateCondition[];
  isOtherwise: boolean;
}

export interface CustomCategoryTemplateRatingRequest {
  id: string | undefined;
  ratingScaleNumericScore: string;
  conditions: CustomCategoryTemplateCondition[];
  isOtherwise: boolean;
}

export interface AddCustomCategoryTemplateRequest {
  id: string | undefined;
  name: string;
  scale: AddCustomCategoryTemplateRequest_Scale;
  conditions: CustomCategoryTemplateCondition[];
  ratings: CustomCategoryTemplateRatingRequest[];
}

export enum AddCustomCategoryTemplateRequest_Scale {
  SCALE_2 = "SCALE_2",
}

export interface GetAutoQaCustomCategoryTemplateRequest {
  id: string;
}

export interface CreateCustomCategoryTemplateRequest {
  template: AddCustomCategoryTemplateRequest | undefined;
  userId: string;
}

export interface UpdateCustomCategoryTemplateRequest {
  template: AddCustomCategoryTemplateRequest | undefined;
  userId: string;
}

export interface RemoveCustomCategoryTemplateRequest {
  id: string;
  userId: string;
}

export interface DeleteAutoQaCategoryCustomPhrasesRequest {
  categoryType: string;
  customPhraseIds: string[];
}

export interface ChangeAutoQaCategoryCustomPhrasesRequest {
  categoryType: string;
  customPhrases: ChangeAutoQaCategoryCustomPhraseRequest[];
}

export interface ChangeAutoQaCategoryCustomPhraseRequest {
  id: string;
  customPhrase: string;
  languages: string[];
}

export interface AddAutoQaCategoryCustomPhrasesRequest {
  categoryType: string;
  customPhrases: AddAutoQaCategoryCustomPhraseRequest[];
}

export interface AddAutoQaCategoryCustomPhraseRequest {
  customPhrase: string;
  languages: string[];
}

export interface AutoQaCategoryCustomPhraseResponse {
  customPhrases: AutoQaCategoryCustomPhrase[];
}

export interface GetAutoQaPromptCategoryTemplateRequest {
  id: string;
}

export interface GetAutoQaPromptCategoryTemplatesRequest {
  accountId: string;
}

export interface CreatePromptCategoryTemplateRequest {
  template: AddPromptCategoryTemplateRequest | undefined;
  userId: string;
}

export interface UpdatePromptCategoryTemplateRequest {
  template: AddPromptCategoryTemplateRequest | undefined;
  userId: string;
}

export interface AddPromptCategoryTemplateRequest {
  id: string;
  scale: AddPromptCategoryTemplateRequest_Scale;
  prompt: string;
  ratings: PromptCategoryTemplateRatingRequest[];
  validationHash?: string | undefined;
  isSpotlightEligible?: boolean | undefined;
  isCategoryEligible?: boolean | undefined;
  isMetadataNeeded?: boolean | undefined;
}

export enum AddPromptCategoryTemplateRequest_Scale {
  SCALE_2 = "SCALE_2",
}

export interface PromptCategoryTemplate {
  id: string;
  scale: AddPromptCategoryTemplateRequest_Scale;
  prompt: string;
  ratings: PromptCategoryTemplateRating[];
  createdAt?: string | undefined;
  updatedAt?: string | undefined;
  promptVersionID?: string | undefined;
}

export interface PromptCategoryTemplateRating {
  id: string;
  position: string;
  ratingScaleNumericScore: string;
  name: string;
  createdAt?: string | undefined;
  updatedAt?: string | undefined;
}

export interface PromptCategoryTemplateRatingRequest {
  id: string;
  ratingScaleNumericScore: string;
  name: string;
}

export interface AutoQaCategorySettingsRequest {
  categoryType: string;
}

export interface AutoQaCategorySettingsResponse {
  customPhrases: AutoQaCategoryCustomPhrase[];
}

export interface AutoQaCategoryCustomPhrase {
  id: string;
  customPhrase: string;
  languages: string[];
  updatedAt: string | undefined;
  updatedBy: string;
}

export interface AutoQaReviewForConversationRequest {
  connectionId: string | undefined;
  conversationId: string | undefined;
}

export interface AutoQaReviewForConversationResponse {
  metadataPerMessage: { [key: string]: MessageMetadata };
  reviewsPerUser: { [key: string]: AutoQaReviews };
  reviewsPerBot: { [key: string]: AutoQaReviews };
}

export interface AutoQaReviewForConversationResponse_MetadataPerMessageEntry {
  key: string;
  value: MessageMetadata | undefined;
}

export interface AutoQaReviewForConversationResponse_ReviewsPerUserEntry {
  key: string;
  value: AutoQaReviews | undefined;
}

export interface AutoQaReviewForConversationResponse_ReviewsPerBotEntry {
  key: string;
  value: AutoQaReviews | undefined;
}

export interface AutoQaReviews {
  reviews: AutoQaReview[];
}

export interface MessageMetadata {
  empathy: boolean | undefined;
  greeting: boolean | undefined;
  mistakes: MessageMistake[];
  closing: boolean | undefined;
  readabilityIssues: ReadabilityIssue[];
  longSentencesCount: string;
}

export interface ReadabilityIssue {
  type: string;
  htmlStartIdx: string;
  htmlEndIdx: string;
}

export interface MessageMistake {
  category: string | undefined;
  description: string | undefined;
  startIdx: string | undefined;
  endIdx: string | undefined;
  htmlStartIdx: string | undefined;
  htmlEndIdx: string | undefined;
  message: string | undefined;
  shortMessage: string | undefined;
  length: string | undefined;
  phrase: string | undefined;
  rule: string | undefined;
  htmlHighlightErrorDebug: string | undefined;
}

export interface AutoQaReview {
  categories: AutoQaRatingCategory[];
  feedback: AutoQaFeedback | undefined;
}

export interface AutoQaFeedback {
  score: number | undefined;
  created: string | undefined;
  updated: string | undefined;
  revieweeName: string | undefined;
  revieweeAvatar: string | undefined;
  ratings: AutoQaFeedbackRating[];
  botRevieweeName: string | undefined;
  botRevieweeAvatar: string | undefined;
  transcriptionId?: string | undefined;
}

export interface AutoQaFeedbackRating {
  categoryId: string;
  rating: number | undefined;
  ratingMax: number;
  scorecardId?: string | undefined;
}

export interface AutoQaRatingCategory {
  id: string;
  rating: string;
  mistakes: AutoQaRatingCategoryMistake[];
  rootCauses: string[];
  model: string;
  undetermined: boolean;
  scorecardId?: string | undefined;
  ratingMax: number;
}

export interface AutoQaRatingCategoryMistake {
  name: string;
  count: string;
}

export interface AutoQaTicketScorePayload {
  accountId: string;
  connectionId: string;
  externalTicketId: string;
  agentScores: AutoQaTicketAgentScore[];
  autoQaTicketReviewUUID: string;
  transcriptionId?: string | undefined;
}

export interface AutoQaTicketAgentScore {
  revieweeExternalId: string;
  greeting?: AutoQaScore | undefined;
  empathy?: AutoQaScore | undefined;
  grammar?: AutoQaScore | undefined;
  closing?: AutoQaScore | undefined;
  tone?: AutoQaScore | undefined;
  solution?: AutoQaScore | undefined;
  readability?: AutoQaScore | undefined;
  issueUnderstanding?: AutoQaScore | undefined;
  personalization?: AutoQaScore | undefined;
  customCategoryScores: AutoQaCustomCategoryScore[];
  isBot: boolean;
  speakerId?: string | undefined;
  customPromptCategoryScores: AutoQaCustomPromptCategoryScore[];
}

export interface AutoQaCustomCategoryScore {
  score: number | undefined;
  customCategoryTemplateId: string;
  customCategoryTemplateRatingId: string | undefined;
  evaluated: boolean;
  model: string;
  isOtherwiseScore: number | undefined;
}

export interface AutoQaCustomPromptCategoryScore {
  score: number | undefined;
  customPromptCategoryTemplateId: string;
  customPromptCategoryTemplateRatingId: string | undefined;
  evaluated: boolean;
  model: string;
  promptVersionID?: string | undefined;
  reasoning: string;
}

export interface GrammarMistakesPerCategory {
  category: string;
  count: number;
}

export interface AutoQaScore {
  score: number | undefined;
  rootCauses: string[];
  grammarMistakesPerCategory: GrammarMistakesPerCategory[];
  evaluated: boolean;
  grammarMessagesCount: GrammarMessagesCount[];
  toneRootCauseCategory: ToneRootCauseCategory[];
  model: string;
  readabilityStatistics: ReadabilityStatistics | undefined;
}

export interface ReadabilityStatistics {
  complexWordCount: string;
  longSentencesCount: string;
  complexWords: string[];
  longSentences: string[];
}

export interface ToneRootCauseCategory {
  category: string;
  rootCauses: string[];
}

export interface GrammarMessagesCount {
  message: string;
  count: number;
  language: string;
}

export interface UpdateSpotlightSettingsRequest {
  spotlight: string;
  type: string;
  conditions: CustomCategoryTemplateCondition[];
  deadAirThreshold?: string | undefined;
}

export interface SpotlightSettingsListResponse {
  spotlights: SpotlightSettingsResponse[];
}

export interface SpotlightSettingsResponse {
  spotlight: string;
  type: string;
  conditions: CustomCategoryTemplateCondition[];
  createdAt: string | undefined;
  deadAirThreshold?: string | undefined;
  searchablePhrases: CustomCategoryTemplateCondition[];
  signal: SpotlightSignal;
  isCustom: boolean;
  name?: string | undefined;
  id: string;
  status?: string | undefined;
}

export interface Spotlight {
  id: string | undefined;
  name: string;
  description?: string | undefined;
  customSpotlight?: AddCustomSpotlightTemplateRequest | undefined;
  promptSpotlight?: AddPromptCategoryTemplateRequest | undefined;
}

export enum Spotlight_Type {
  DEAD_AIR = "DEAD_AIR",
  CHURN_RISK = "CHURN_RISK",
  RECORDING_DISCLOSURE = "RECORDING_DISCLOSURE",
}

export interface SpotlightResponse {
  id: string;
  name: string;
  description?: string | undefined;
  status: string;
  promptSpotlight?: PromptCategoryTemplate | undefined;
  customSpotlight?: SpotlightSettingsResponse | undefined;
}

export interface GetSpotlightRequest {
  id: string;
}

export interface GetSpotlightResponse {
  id: string;
  name: string;
  description?: string | undefined;
  status: string;
  promptSpotlight?: PromptCategoryTemplate | undefined;
  customSpotlight?: SpotlightSettingsResponse | undefined;
  systemSpotlight?: SpotlightSettingsResponse | undefined;
}

export interface AddCustomSpotlightTemplateRequest {
  conditions: CustomCategoryTemplateCondition[];
  searchablePhrases: CustomCategoryTemplateCondition[];
  signal?: SpotlightSignal | undefined;
}

export interface AddCustomSpotlightRequest {
  name: string;
  conditions: CustomCategoryTemplateCondition[];
  searchablePhrases: CustomCategoryTemplateCondition[];
  signal?: SpotlightSignal | undefined;
}

export interface UpdateCustomSpotlightRequest {
  id: string;
  name: string;
  conditions: CustomCategoryTemplateCondition[];
  searchablePhrases: CustomCategoryTemplateCondition[];
  signal?: SpotlightSignal | undefined;
}

export interface DeleteCustomSpotlightRequest {
  id: string;
}

export interface DeleteCustomCategoryTemplateRequest {
  id: string;
}

export interface GetAutoQaPromptCategoryTemplatesResponse {
  templates: PromptCategoryTemplate[];
}

export interface DeleteAutoQaReviewByTranscriptionRequest {
  accountId: string;
  connectionId: string;
  workspaceId: string;
  revieweeExternalId: string;
  externalTicketId: string;
  transcriptionId: string;
}

export interface DeleteAutoQaReviewByTranscriptionResponse {
}

export interface AiInsights {
}

export interface AiInsights_GetAiInsightsResponse {
  data: AiInsights_AiInsightListItem[];
  total: string;
}

export interface AiInsights_UpdateSpotlightStatusRequest {
  id: string;
  status: string;
}

export interface AiInsights_AiInsightListItem {
  id: string;
  name: string;
  type: AiInsights_AiInsightListItem_Type;
  status: AiInsights_AiInsightListItem_Status;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  entityType: AiInsights_AiInsightListItem_EntityType;
  description?: string | undefined;
}

export enum AiInsights_AiInsightListItem_Status {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
}

export enum AiInsights_AiInsightListItem_Type {
  GRAMMAR = "GRAMMAR",
  EMPATHY = "EMPATHY",
  GREETING = "GREETING",
  CLOSING = "CLOSING",
  READABILITY = "READABILITY",
  TONE = "TONE",
  COMPREHENSION = "COMPREHENSION",
  SOLUTION = "SOLUTION",
  CUSTOM = "CUSTOM",
  PROMPT = "PROMPT",
  DEAD_AIR = "DEAD_AIR",
  RECORDING_DISCLOSURE = "RECORDING_DISCLOSURE",
}

export enum AiInsights_AiInsightListItem_EntityType {
  CATEGORY = "CATEGORY",
  SPOTLIGHT = "SPOTLIGHT",
}

export interface AiInsights_ValidatePromptTemplateRequest {
  prompt: string;
  ratings: AiInsights_PromptTemplateRating[];
}

export interface AiInsights_PromptTemplateRating {
  name: string;
}

export interface AiInsights_ValidatePromptTemplateResponse {
  validationHash: string;
  isCategoryEligible?: boolean | undefined;
  isSpotlightEligible?: boolean | undefined;
  warnings: AiInsights_ValidationWarning | undefined;
  isMetadataNeeded?: boolean | undefined;
}

export interface AiInsights_ValidationWarning {
  body: AiInsights_ValidationWarningMessage | undefined;
  answers: AiInsights_ValidationWarningMessage[];
}

export interface AiInsights_ValidationWarningMessage {
  messages: string[];
  index: number | undefined;
}

export interface AiInsights_GetAvailableEntityCountsResponse {
  promptInsightsAvailable: number;
  textMatchInsightsAvailable: number;
  promptInsightsLimit: number;
  textMatchInsightsLimit: number;
}

export interface AutoQa {
  /** GetAutoQaConversationReviews returns autoQaReviews for conversation */
  GetAutoQaConversationReviews(
    request: AutoQaReviewForConversationRequest,
  ): Promise<AutoQaReviewForConversationResponse>;
  GetAutoQaCategorySettings(request: AutoQaCategorySettingsRequest): Promise<AutoQaCategorySettingsResponse>;
  AddAutoQaCategoryCustomPhrases(
    request: AddAutoQaCategoryCustomPhrasesRequest,
  ): Promise<AutoQaCategoryCustomPhraseResponse>;
  ChangeAutoQaCategoryCustomPhrases(
    request: ChangeAutoQaCategoryCustomPhrasesRequest,
  ): Promise<AutoQaCategoryCustomPhraseResponse>;
  DeleteAutoQaCategoryCustomPhrases(request: DeleteAutoQaCategoryCustomPhrasesRequest): Promise<Empty>;
  GetAutoQaCustomCategoryTemplateFilters(request: Empty): Promise<CustomCategoryTemplateFiltersResponse>;
  GetAutoQaCustomCategoryTemplates(request: Empty): Promise<CustomCategoryTemplatesResponse>;
  GetAutoQaSpotlightConditions(request: Empty): Promise<SpotlightConditionResponse>;
  AddAutoQaCustomCategoryTemplates(request: AddCustomCategoryTemplateRequest): Promise<CustomCategoryTemplatesResponse>;
  ChangeAutoQaCustomCategoryTemplate(request: AddCustomCategoryTemplateRequest): Promise<Empty>;
  UpdateAutoQaSpotlightSettings(request: UpdateSpotlightSettingsRequest): Promise<SpotlightSettingsResponse>;
  GetAutoQaSpotlightsSettings(request: Empty): Promise<SpotlightSettingsListResponse>;
  AddCustomSpotlight(request: AddCustomSpotlightRequest): Promise<SpotlightSettingsResponse>;
  UpdateCustomSpotlight(request: UpdateCustomSpotlightRequest): Promise<SpotlightSettingsResponse>;
  DeleteCustomSpotlight(request: DeleteCustomSpotlightRequest): Promise<Empty>;
  DeleteAutoQaCustomCategoryTemplate(request: DeleteCustomCategoryTemplateRequest): Promise<Empty>;
  GetAiInsights(request: Empty): Promise<AiInsights_GetAiInsightsResponse>;
  CreateSpotlight(request: Spotlight): Promise<SpotlightResponse>;
  UpdateSpotlightStatus(request: AiInsights_UpdateSpotlightStatusRequest): Promise<Empty>;
  UpdateSpotlight(request: Spotlight): Promise<SpotlightResponse>;
  GetSpotlight(request: GetSpotlightRequest): Promise<GetSpotlightResponse>;
  ValidatePromptTemplate(
    request: AiInsights_ValidatePromptTemplateRequest,
  ): Promise<AiInsights_ValidatePromptTemplateResponse>;
}

export interface AutoQaInternal {
  GetAutoQaCustomCategoryTemplate(request: GetAutoQaCustomCategoryTemplateRequest): Promise<CustomCategoryTemplate>;
  CreateAutoQaCustomCategoryTemplate(request: CreateCustomCategoryTemplateRequest): Promise<CustomCategoryTemplate>;
  UpdateAutoQaCustomCategoryTemplate(request: UpdateCustomCategoryTemplateRequest): Promise<CustomCategoryTemplate>;
  RemoveAutoQaCustomCategoryTemplate(request: RemoveCustomCategoryTemplateRequest): Promise<Empty>;
  CreateAutoQaPromptCategoryTemplate(request: CreatePromptCategoryTemplateRequest): Promise<PromptCategoryTemplate>;
  GetAutoQaPromptCategoryTemplate(request: GetAutoQaPromptCategoryTemplateRequest): Promise<PromptCategoryTemplate>;
  UpdateAutoQaPromptCategoryTemplate(request: UpdatePromptCategoryTemplateRequest): Promise<PromptCategoryTemplate>;
  GetAutoQaPromptCategoryTemplates(
    request: GetAutoQaPromptCategoryTemplatesRequest,
  ): Promise<GetAutoQaPromptCategoryTemplatesResponse>;
  DeleteAutoQaReviewByTranscription(
    request: DeleteAutoQaReviewByTranscriptionRequest,
  ): Promise<DeleteAutoQaReviewByTranscriptionResponse>;
  GetAvailableEntityCounts(request: Empty): Promise<AiInsights_GetAvailableEntityCountsResponse>;
}
